import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import Retelling from '@/components/screens/retelling/Retelling';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IRetelling } from '@/interfaces/retelling.interface';

interface IRetellingPageDynamicProps {
  books: IRetelling;
}

const RetellingPageDynamic: NextPage<IRetellingPageDynamicProps> = ({ books }) => {
  return <Retelling books={books} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}satellite/retelling/?page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}`);
  const books = await res.json();

  // Check Fetched Data
  if (books?.data.length === 0) {
    return {
      notFound: true,
    };
  }

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default RetellingPageDynamic;
